export class AddressType {
  id: number;
  name: string;
  icon: string;
}
